<h1>Ron Wyatt</h1>
<h2>1933<small>CE</small>-1999<small>CE</small></h2>
<p>American nurse anesthetist/Unaccredited pseudo-archaeologist</p>
<ul>
	<li>Claimed to have made almost 100 biblical archaeology discoveries.</li>
	<li>Called fraudulent by other <a [appLink]="'https://web.archive.org/web/20030211052724/http://www.answersingenesis.org/docs2002/1011hovind.asp'">creationists.</a></li>
	<li>He never provided the name of the lab that tested the claimed blood of Jesus and no lab has come forward stating their involvement.</li>
</ul>
<h3>Alleged Discoveries</h3>
<ul>
	<li>Noah's Home and a Flood-inscription at that site.</li>
	<li>Fences from Noah's farm.</li>
	<li>Anchor Stones from Noah's Ark.</li>
	<li>Laminated Deck Timber from the Ark.</li>
	<li>Noah's Altar.</li>
	<li>Tombs with Tombstones of Noah and his wife.</li>
	<li>The precise location of the Red Sea Crossing.</li>
	<li>Wheels from Egyptian Chariots involved in the pursuit of the Israelites from Egypt.</li>
	<li>The Book of the Law written by Moses on Animal Skins.</li>
	<li>Gold from the Golden Calf fashioned by Aaron.</li>
	<li>The Ark of the Covenant.</li>
	<li>Tables of the Ten Commandments.</li>
	<li>The Tabernacle's Table of the Showbread.</li>
	<li>Goliath's Sword.</li>
	<li>Jesus' Tomb and the Stone Seal of the Tomb.</li>
	<li>Christ's Dried "living" Blood.</li>
	<li>The Red Sea Crossing.</li>
	<li>Mt. Sinai.</li>
	<li>Sodom and Gomorrah.</li>
	<li>The site of Jesus' crucifixion.</li>
	<li>The Cave of MachPelah.</li>
	<li>The Tower of Babel.</li>
	<li>The Rock of Rephidim.</li>
</ul>
<div class="sideBySide">
	<div><img [appBiggen]="{ 'size': '20dvw', 'axis': 'width' }" src="GardenTomb_letter.jpg" style="aspect-ratio: 1.3108614232209737827715355805243/1;" alt="A letter from the Garden Tomb renouncing Ron Wyatt." title="A letter from the Garden Tomb renouncing Ron Wyatt." /></div>
	<div>
		<div>The Garden Tomb letter refuting Ron Wyatt. It is available from The Garden Tomb upon request.</div>
	</div>
</div>